import axios from 'axios';
import AuthService from '@/services/auth.service';

const laravelApiClient = axios.create({
  baseURL: process.env.VUE_APP_QUEUE_API,
  withCredentials: true,
});

let refreshPromise = null;

const isRefreshRequest = (config) =>
  Boolean(config?.url && config.url.includes('/sanctum/refresh'));

laravelApiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (
      !error.response ||
      error.response.status !== 401 ||
      !originalRequest ||
      originalRequest._retry ||
      isRefreshRequest(originalRequest)
    ) {
      return Promise.reject(error);
    }

    originalRequest._retry = true;

    try {
      if (!refreshPromise) {
        refreshPromise = AuthService.refreshToken().finally(() => {
          refreshPromise = null;
        });
      }

      const newTokens = await refreshPromise;
      originalRequest.headers = originalRequest.headers || {};
      originalRequest.headers['Authorization'] = `Bearer ${newTokens.lar_token}`;

      return laravelApiClient(originalRequest);
    } catch (refreshError) {
      AuthService.logout();
      return Promise.reject(refreshError);
    }
  }
);

export default laravelApiClient;
